import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { WalletProvider } from './contexts/WalletContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { AuthProvider } from './contexts/AuthContext';
import DashboardLayout from './components/layout/DashboardLayout';
import LoginPage from './components/auth/LoginPage';
import OverviewPage from './pages/OverviewPage';
import ClientProfilePage from './pages/ClientProfilePage';
import PoliciesPage from './pages/PoliciesPage';
import DAppsListPage from './pages/DAppsListPage';
import DAppDetailPage from './pages/DAppDetailPage';
import OnboardingPage from './pages/OnboardingPage';
import BillingPageDisabled from './pages/BillingPageDisabled';
import './styles/themes.css';
import './App.css';

function App() {
  return (
    <ThemeProvider>
      <WalletProvider>
        <AuthProvider>
          <Router>
            <div className="App">
              <Routes>
                <Route path="/login" element={<LoginPage />} />
                <Route element={<DashboardLayout />}>
                  <Route path="/" element={<OverviewPage />} />
                  <Route path="/client" element={<ClientProfilePage />} />
                  <Route path="/policies" element={<PoliciesPage />} />
                  <Route path="/billing" element={<BillingPageDisabled />} />
                  <Route path="/dapps" element={<DAppsListPage />} />
                  <Route path="/dapps/new" element={<OnboardingPage />} />
                  <Route
                    path="/dapps/:chainId/:contractAddress"
                    element={<DAppDetailPage />}
                  />
                </Route>
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </div>
          </Router>
        </AuthProvider>
      </WalletProvider>
    </ThemeProvider>
  );
}

export default App;
